<template>
  <div class="content-wrapper">
    <h2 class="page-titles">Gift Cards</h2>
    <div class="margin-top-1">
      <GiftCardsList />
    </div>
  </div>
</template>

<script>
import { layouts } from '@/helpers'
export default {
  name: 'EcommerceGiftCards',
  data() {
    return {}
  },
  components: {
    GiftCardsList: () => import('./EcommerceGiftCardsList')
  },
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
  }
}
</script>

<style lang="scss" scoped>
.justify-end {
  justify-content: end !important;
}
.gift-card-button-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-items: flex-end;
  padding-top: 1.25rem;

  .search-input {
    width: 30%;
  }

  .button-gemnote {
    font-weight: normal;
    height: 2.5rem;
    padding: 0 18px;

    span {
      margin-left: 6px;
    }
  }
}

@media screen and (max-width: 630px) and (min-width: 350px) {
  .gift-card-button-wrapper {
    display: flex;
    gap: 1rem;
    flex-direction: column;
    align-items: flex-start;
    &.justify-end {
      align-items: flex-end;
      justify-content: end !important;
    }
    .search-input {
      flex: 0;
    }
  }
}
</style>
